import React from "react";
import { toast } from "react-toastify";

import useOnlineOrders from "./hooks/useOnlineOrders";
import OrderListView from "./components/OrderListView";
import OrderDetailView from "./components/OrderDetailView";
import OrderPopup from "../../components/OrderManagement/OrderPopup";

// Keep CSS import — popup overlay/box classes used by OrderPopup
import "./NewOrderDetails.css";

const OnlineOrders = () => {
    const {
        reasons,
        displayStatuses,
        orders,
        searchTerm,
        setSearchTerm,
        selectedSort,
        filteredOrders,
        selectedOrder,
        setSelectedOrder,
        newStatus,
        setNewStatus,
        statusHistory,
        rows,
        showSubmitButton,
        suggestions,
        deleteIndex,
        setDeleteIndex,
        showDeletePopup,
        setShowDeletePopup,
        selectedReasons,
        setSelectedReasons,
        isFinalStageSelection,
        popupOrder,
        setPopupOrder,
        isRejecting,
        setIsRejecting,
        selectedRejectReason,
        setSelectedRejectReason,
        isFinalStagePopup,
        address,
        setAddress,
        addressOptions,
        driverList,
        driverId,
        setDriverId,
        driverName,
        setDriverName,
        driverMobile,
        setDriverMobile,
        useNewDriver,
        setUseNewDriver,
        handleStatusClick,
        getCountByStatus,
        getNextStatuses,
        getStatusColor,
        updatePopupOrderStatus,
        updateOrderStatus,
        updatePopupOrderStatusReject,
        handleSelectSuggestion,
        handleAddRow,
        handleChange,
        handleSubmit,
        handleProductDelete,
        activeSuggestionIndex,
        setActiveSuggestionIndex,

    } = useOnlineOrders();

    return (
        <div className="min-h-screen overflow-y-auto bg-gray-50 pb-20">
            <div className="max-w-[1200px] mx-auto px-4 py-4 sm:px-6">
                {selectedOrder ? (
                    <OrderDetailView
                        selectedOrder={selectedOrder}
                        setSelectedOrder={setSelectedOrder}
                        newStatus={newStatus}
                        setNewStatus={setNewStatus}
                        statusHistory={statusHistory}
                        rows={rows}
                        showSubmitButton={showSubmitButton}
                        suggestions={suggestions}
                        deleteIndex={deleteIndex}
                        setDeleteIndex={setDeleteIndex}
                        showDeletePopup={showDeletePopup}
                        setShowDeletePopup={setShowDeletePopup}
                        selectedReasons={selectedReasons}
                        setSelectedReasons={setSelectedReasons}
                        isFinalStageSelection={isFinalStageSelection}
                        address={address}
                        setAddress={setAddress}
                        addressOptions={addressOptions}
                        driverList={driverList}
                        driverId={driverId}
                        setDriverId={setDriverId}
                        driverName={driverName}
                        setDriverName={setDriverName}
                        driverMobile={driverMobile}
                        setDriverMobile={setDriverMobile}
                        useNewDriver={useNewDriver}
                        setUseNewDriver={setUseNewDriver}
                        reasons={reasons}
                        handleChange={handleChange}
                        handleSelectSuggestion={handleSelectSuggestion}
                        handleAddRow={handleAddRow}
                        handleSubmit={handleSubmit}
                        handleProductDelete={handleProductDelete}
                        getNextStatuses={getNextStatuses}
                        updateOrderStatus={updateOrderStatus}
                        activeSuggestionIndex={activeSuggestionIndex}
                        setActiveSuggestionIndex={setActiveSuggestionIndex}

                    />
                ) : (
                    <OrderListView
                        orders={orders}
                        filteredOrders={filteredOrders}
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                        selectedSort={selectedSort}
                        displayStatuses={displayStatuses}
                        handleStatusClick={handleStatusClick}
                        getCountByStatus={getCountByStatus}
                        getStatusColor={getStatusColor}
                        setPopupOrder={setPopupOrder}
                        setAddress={setAddress}
                        setDriverId={setDriverId}
                        setDriverName={setDriverName}
                        setDriverMobile={setDriverMobile}
                        setUseNewDriver={setUseNewDriver}
                    />
                )}

                <OrderPopup
                    popupOrder={popupOrder}
                    rows={rows}
                    address={address}
                    addressOptions={addressOptions}
                    driverList={driverList}
                    driverId={driverId}
                    driverName={driverName}
                    driverMobile={driverMobile}
                    useNewDriver={useNewDriver}
                    isFinalStagePopup={isFinalStagePopup}
                    reasons={reasons}
                    selectedRejectReason={selectedRejectReason}
                    isRejecting={isRejecting}
                    setPopupOrder={setPopupOrder}
                    setAddress={setAddress}
                    setDriverId={setDriverId}
                    setDriverName={setDriverName}
                    setDriverMobile={setDriverMobile}
                    setUseNewDriver={setUseNewDriver}
                    setIsRejecting={setIsRejecting}
                    setSelectedRejectReason={setSelectedRejectReason}
                    updatePopupOrderStatus={updatePopupOrderStatus}
                    updatePopupOrderStatusReject={updatePopupOrderStatusReject}
                    getNextStatuses={getNextStatuses}
                    toast={toast}
                    setSelectedOrder={setSelectedOrder}
                />
            </div>
        </div>
    );
};

export default OnlineOrders;
